import themeSettings from '@theme/settings'

export default ({}, inject) => {
  // Inject themeSettings to context
  inject('themeSettings', themeSettings || {})
}
